import { render, staticRenderFns } from "./DialogRoot.vue?vue&type=template&id=0c95bcac&"
import script from "./DialogRoot.vue?vue&type=script&lang=ts&"
export * from "./DialogRoot.vue?vue&type=script&lang=ts&"
import style0 from "./Dialog.style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports